//# sourceMappingURL=page-reference.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/page-reference.interface.js
// module id = 1179
// module chunks = 4